export default function getStorage() {
  return window.localStorage;
}